import React, { useState, useEffect, useMemo } from 'react';
import { Field } from 'formik';
import { connect } from 'react-redux';
import { Grid, Dropdown as DropdownNativo, Dropdown } from 'semantic-ui-react';
import { ProposalsFilterData } from '../types';
import Button from '../../../components/Button';
import { iRootDispatch, iRootState } from '../../../store';
import AppMaskedInput from '../../../components/MaskedInput';
import CustomDatePicker from '../../../components/CustomDatePicker';
import { FieldLabel } from '../../../styles';
import Input from '../../../components/Input';
import BondInsuranceProposalsTable from './BondInsuranceProposalsTable';
import {
  getBrokerBondInsuranceProposals,
  useDropDownUsers
} from '../../../services/broker';
import { sortBondInsuranceProposals } from '../../../services/bond-insurance-proposal';
import {
  AvailableBrokersAndEstatesState,
  InsurersListState
} from '../../../store/types/temp-types';
import { BondInsuranceProposalsListProps } from '../BondInsuranceProposalsForm';
import { CustoDropDownItemProps } from '../../../components/types';
import { dangerNotification } from '../../../services/notification';
import { ProposalForGetBondInsuranceProposalsListResponseDTO } from '../../../dtos/bond-insurance-proposal-list/interfaces/proposal-for-get-bond-insurance-proposals-list-response-dto';
import { GetBondInsuranceProposalsListResponseDTO } from '../../../dtos/bond-insurance-proposal-list/get-bond-insurance-proposals-list-response-dto';
import { UsersToCustomDropDownOptions } from '../../../util';
import { InsurerState } from '../../../types/InsurerState';
import { useLocation } from 'react-router-dom';
import { isBackOfficeUser } from '../../../utils/isBackOfficeUser';
import EstateUnitFilter from '../../../components/EstateUnitFilter';
import { appendEstateUnitIdToFilter } from '../../../utils/estateUnitFilter.util';
import PopupModal from '../../../components/PopupModal';
import { BannerLocationActivationEnum } from '../../../types/Banner';
import { typeOptions } from '../../find-record/types/options-find.type';
import { ButtonsContainer } from '../styles';

interface LocationState {
  bondInsuranceId?: string;
}

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user,
  insurers: state.insurers
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(
      availableBrokers
    ),

  updateInsurersList: (insurers: InsurersListState) =>
    dispatch.insurers.updateInsurersList(insurers)
});

interface DropdownOptions {
  index: number;
  value: number | string;
  text: string;
}

const hiredDataStatusList: DropdownOptions[] = [
  {
    index: 0,
    value: 'Todos',
    text: 'Todos'
  },
  {
    index: 1,
    value: 'Contratação em Andamento',
    text: 'Contratação em Andamento'
  },
  {
    index: 2,
    value: 'Erro na Contratação',
    text: 'Erro na Contratação'
  },
  {
    index: 3,
    value: 'Contratação integrada em Andamento',
    text: 'Contratação integrada em Andamento'
  }
];

const w100 = {
  width: '100%'
};

const BondInsuranceProposalsPage = (props: BondInsuranceProposalsListProps) => {
  const { id } = props.match.params;
  const location = useLocation();
  const { availableBrokersAndEstates, user, setFieldValue, values } = props;
  const brokers: CustoDropDownItemProps[] = availableBrokersAndEstates.brokers;
  const estates: CustoDropDownItemProps[] = availableBrokersAndEstates.estates;
  const [bondInsuranceProposals, setBondInsuranceProposals] = useState<
    ProposalForGetBondInsuranceProposalsListResponseDTO[]
  >([]);
  const insurers: InsurerState[] | null =
    props.availableBrokersAndEstates.bondInsurers.map((insurer: any) => insurer.value);
  const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [ascendingOrder, setAscendingOrder] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dataCount, setDataCount] = useState<number>(0);
  const [startFilter, setStartFilter] = useState<Date | null>();
  const [endFilter, setEndFilter] = useState<Date | null>();
  const [selectedEstate, setSelectedEstate] = useState<any>();
  const [estateUnitIdFilter, setEstateUnitIdFilter] = useState('');
  const [selectableStatus, setSelectableStatus] = useState<string>('Todos');
  const [status, setStatus] = useState<number>(0);
  const statusList: DropdownOptions[] = hiredDataStatusList;
  const bondInsuranceIdInitialValue = (location.state as LocationState)?.bondInsuranceId;
  const [bondInsuranceId, setBondInsuranceId] = useState<any>(
    bondInsuranceIdInitialValue
  );
  const selectableInsurers = insurers.map(insurer => ({
    index: insurer.id,
    value: insurer.id,
    text: insurer.name
  }));
  const [selectedInsurer, setSelectedInsurer] = useState<string>('');
  const [selectedAccountManager, setSelectedAccountManager] = useState<string | null>(
    null
  );
  const [type, setType] = useState<any>('document');
  const [argument, setArgument] = useState<string>('');

  const {
    data: usersData,
    isLoading: isAccountManagerLoading,
    isError: isAccountManagerFetchError
  } = useDropDownUsers(props?.user?.broker?.id);

  const isBackOffice = isBackOfficeUser();

  const accountManagerOptions = useMemo(() => {
    if (!usersData) return [];

    const convertedValues = usersData.map((user: any) => ({
      id: user.id,
      name: user.name
    }));

    return UsersToCustomDropDownOptions(false, convertedValues);
  }, [usersData]);

  useEffect(() => {
    if (isAccountManagerFetchError) {
      dangerNotification(
        'Oops...',
        'Não foi possível encontrar os analistas disponíveis'
      );
    }
  }, [isAccountManagerFetchError]);

  const handleNewChangeAccountManager = (accountManagerKey: string) => {
    if (accountManagerKey !== '') {
      setSelectedAccountManager(accountManagerKey);
    } else {
      setSelectedAccountManager(null);
    }
  };

  useEffect(() => {
    const newStart = startFilter ? startFilter.toISOString().substring(0, 10) : '';
    setFieldValue('start', newStart);
  }, [startFilter, endFilter]);

  useEffect(() => {
    const newEnd = endFilter ? endFilter.toISOString().substring(0, 10) : '';
    setFieldValue('end', newEnd);
  }, [endFilter]);

  useEffect(() => {
    const id = selectedEstate && selectedEstate !== '' ? selectedEstate.id : '';
    setFieldValue('estate_id', id);
  }, [selectedEstate]);

  useEffect(() => {
    setFieldValue('status', status);
  }, [status]);

  useEffect(() => {
    setFieldValue('insurer', selectedInsurer);
  }, [selectedInsurer]);

  const argumentToField = (type: string, value: string) => {
    switch (type) {
      case 'name':
        setFieldValue('name', value);
        break;
      case 'address':
        setFieldValue('address', value);
        break;
      case 'document':
        setFieldValue('document', value);
        break;
      case 'property_document':
        setFieldValue('property_document', value);
        break;
      case 'property_name':
        setFieldValue('property_name', value);
        break;
    }
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'argument') {
      argumentToField(type, value);
      setArgument(value);
      return;
    }

    switch (name) {
      case 'start':
        setFieldValue('start', value);
        break;
      case 'end':
        setFieldValue('end', value);
        break;
    }
  };

  const clearSearchArgument = () => {
    setFieldValue('name', '');
    setFieldValue('address', '');
    setFieldValue('document', '');
    setFieldValue('property_document', '');
    setFieldValue('property_name', '');
  };

  const handleTypeChange = (value: string) => {
    clearSearchArgument();
    setType(value);
    argumentToField(value, argument);
  };

  async function loadTotal(filter: Partial<ProposalsFilterData>) {
    if (currentPage === 1) {
      const data: GetBondInsuranceProposalsListResponseDTO =
        await getBrokerBondInsuranceProposals(currentPage, {
          ...filter,
          action: 'COUNT'
        });
      setDataCount(data.count);
    }
  }

  const getData = async (isClear = false) => {
    setIsLoading(true);

    try {
      const filter: Partial<ProposalsFilterData> = values;

      if (bondInsuranceId) filter.bondInsuranceId = bondInsuranceId;

      if (estates.length === 1) filter.estate_id = estates[0].value.id;

      if (brokers.length === 1) filter.broker_id = brokers[0].value.id;

      if (selectedAccountManager) filter.accountManager = selectedAccountManager;

      delete filter.broker_id;

      if (!id) {
        const requestFilter = appendEstateUnitIdToFilter(
          isClear ? {} : filter,
          estateUnitIdFilter
        );
        const data: GetBondInsuranceProposalsListResponseDTO =
          await getBrokerBondInsuranceProposals(currentPage, requestFilter);

        const orderedProposals: ProposalForGetBondInsuranceProposalsListResponseDTO[] =
          data.proposals.length > 1
            ? sortBondInsuranceProposals(data.proposals, ascendingOrder)
            : data.proposals;

        loadTotal(
          appendEstateUnitIdToFilter(isClear ? {} : filter, estateUnitIdFilter)
        );
        setBondInsuranceProposals(orderedProposals);
      }

      setBondInsuranceId(undefined);

      filter.bondInsuranceId = undefined;

      setFieldValue('bondInsuranceId', undefined);
      setIsLoading(false);
    } catch (e) {
      dangerNotification('Oops...', 'Não foi possível buscar as propostas');
    } finally {
      setIsLoading(false);
    }
  };

  const clearInputs = () => {
    setFieldValue('name', '');
    setFieldValue('address', '');
    setFieldValue('document', '');
    setFieldValue('property_document', '');
    setFieldValue('property_name', '');
    setFieldValue('start', '');
    setFieldValue('end', '');
    setFieldValue('estate_id', null);
    setFieldValue('insurer', '');
    setFieldValue('bondInsuranceId', undefined);
    setFieldValue('accountManagerId', undefined);
    setStatus(0);
    setSelectableStatus('Todos');
    setSelectedEstate(null);
    setSelectedInsurer('');
    setStartFilter(null);
    setEndFilter(null);
    setBondInsuranceId(undefined);
    setSelectedAccountManager(null);
    setEstateUnitIdFilter('');
    setArgument('');
    setType('document');
  };

  useEffect(() => {
    window.history.replaceState(
      {
        ...(location.state as any),
        bondInsuranceId: undefined
      },
      ''
    );
  }, [location]);

  useEffect(() => {
    if (!isFirstLoading) getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    if (!isBackOffice) getData();

    setIsFirstLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setCurrentPage(1);
    setIsFirstLoading(false);
    getData();
  };

  const dropdownOptions = typeOptions.slice(0, -2);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <FieldLabel>Pesquisar por</FieldLabel>
              <div style={w100}>
                <Dropdown
                  style={w100}
                  value={type}
                  name="type"
                  options={dropdownOptions}
                  placeholder={'Selecionar...'}
                  search
                  selection
                  disabled={isLoading}
                  onChange={(e, { value }) => {
                    handleTypeChange(value as string);
                  }}
                  clearable
                />
              </div>
            </Grid.Column>
            <Grid.Column width={4}>
              <FieldLabel>Termo de pesquisa:</FieldLabel>
              <Input
                name="argument"
                onChange={handleInputChange}
                disabled={isLoading}
                value={argument}
                fluid
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <FieldLabel>Seguradora:</FieldLabel>
              <div style={w100}>
                <DropdownNativo
                  style={w100}
                  value={selectedInsurer}
                  name={`insurer`}
                  defaultValue={
                    selectableInsurers.length === 1 ? selectableInsurers[0].value : ''
                  }
                  disabled={isLoading || selectableInsurers.length === 1}
                  options={selectableInsurers || []}
                  placeholder={'Selecionar...'}
                  search
                  selection
                  onChange={(e, { value }) => setSelectedInsurer(String(value))}
                  clearable
                />
              </div>
            </Grid.Column>
            {isBackOffice && (
              <Grid.Column width={3}>
                <FieldLabel>Imobiliária:</FieldLabel>
                <div style={w100}>
                  <DropdownNativo
                    style={w100}
                    value={selectedEstate}
                    name={`estate`}
                    defaultValue={
                      availableBrokersAndEstates.estates.length === 1
                        ? availableBrokersAndEstates.estates[0].value
                        : ''
                    }
                    disabled={
                      isLoading || availableBrokersAndEstates.estates.length === 1
                    }
                    options={availableBrokersAndEstates.estates || []}
                    placeholder={'Selecionar...'}
                    search
                    selection
                    onChange={(e, { value }) => setSelectedEstate(value)}
                    clearable
                  />
                </div>
              </Grid.Column>
            )}
            <EstateUnitFilter
              columnWidth={3}
              estateId={String(values.estate_id || selectedEstate?.id || '')}
              value={estateUnitIdFilter}
              onChange={setEstateUnitIdFilter}
            />
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>
              <FieldLabel>Data Inicial:</FieldLabel>
              <Field
                name={`start`}
                selected={startFilter ? startFilter : ''}
                onChange={setStartFilter}
                component={CustomDatePicker}
                disabled={isLoading}
                customInput={
                  <AppMaskedInput
                    mask={[
                      /[0-9]/,
                      /[0-9]/,
                      '/',
                      /[0-9]/,
                      /[0-9]/,
                      '/',
                      /[0-9]/,
                      /[0-9]/,
                      /[0-9]/,
                      /[0-9]/
                    ]}
                  />
                }
                dateFormat={'dd/MM/yyyy'}
              />
            </Grid.Column>

            <Grid.Column width={2}>
              <FieldLabel>Data Final:</FieldLabel>
              <Field
                name={`end`}
                selected={endFilter ? endFilter : ''}
                onChange={setEndFilter}
                component={CustomDatePicker}
                disabled={isLoading}
                customInput={
                  <AppMaskedInput
                    mask={[
                      /[0-9]/,
                      /[0-9]/,
                      '/',
                      /[0-9]/,
                      /[0-9]/,
                      '/',
                      /[0-9]/,
                      /[0-9]/,
                      /[0-9]/,
                      /[0-9]/
                    ]}
                  />
                }
                dateFormat={'dd/MM/yyyy'}
              />
            </Grid.Column>

            <Grid.Column width={3}>
              <FieldLabel>Status:</FieldLabel>
              <div style={w100}>
                <DropdownNativo
                  style={w100}
                  value={selectableStatus}
                  name={`status`}
                  defaultValue={statusList.length === 1 ? statusList[0].value : ''}
                  disabled={isLoading || statusList.length === 1}
                  options={statusList || []}
                  placeholder={'Selecionar...'}
                  search
                  selection
                  onChange={(e, { value }) => {
                    setSelectableStatus(String(value));
                    switch (value) {
                      case 'Todos':
                        setStatus(0);
                        break;
                      case 'Contratação em Andamento':
                        setStatus(1);
                        break;
                      case 'Erro na Contratação':
                        setStatus(2);
                        break;
                      case 'Contratação integrada em Andamento':
                        setStatus(5);
                        break;
                      default:
                        setStatus(0);
                        break;
                    }
                  }}
                  clearable
                />
              </div>
            </Grid.Column>

            {!user.role.includes('ESTATE') && (
              <Grid.Column width={3}>
                <FieldLabel>Gestor de Contas:</FieldLabel>
                <div style={w100}>
                  <DropdownNativo
                    style={w100}
                    value={selectedAccountManager || undefined}
                    name={`accountManager`}
                    options={accountManagerOptions}
                    disabled={isLoading || isAccountManagerLoading}
                    loading={isAccountManagerLoading}
                    placeholder={'Selecionar...'}
                    search
                    selection
                    onChange={(e, { value }) =>
                      handleNewChangeAccountManager(value as string)
                    }
                    clearable
                  />
                </div>
              </Grid.Column>
            )}
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}></Grid.Column>
            <Grid.Column width={4}>
              <ButtonsContainer>
                <Button
                  fluid
                  type={'submit'}
                  disabled={isLoading}
                  text="Pesquisar"
                  onClick={handleSubmit}
                />
                <Button
                  light
                  fluid
                  type={'button'}
                  disabled={isLoading}
                  text="Limpar"
                  onClick={() => {
                    clearInputs();
                    getData(true);
                  }}
                />
              </ButtonsContainer>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </form>
      <BondInsuranceProposalsTable
        bondInsuranceProposals={bondInsuranceProposals}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        getData={getData}
        dataCount={dataCount}
      />
      <PopupModal
        locationActivation={BannerLocationActivationEnum.BOND_INSURANCE_PROPOSAL_LIST}
      />
    </>
  );
};

export default connect(mapState, mapDispatch)(BondInsuranceProposalsPage);
